<template>
  <div class="portal-item__container" @click="handleRedirection">
    <div class="portal-item__title">
      {{ text }}
    </div>
    <div class="portal-item__image">
      <img :src="icon" alt="app-icon-selected">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortalCard',
  props: {
    text: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: ''
    },
  },
  methods: {
    handleRedirection() {
      window.open(this.url, "_blank");
    }
  }
}
</script>

<style lang="scss" scoped>
.portal-item__container {
  cursor: pointer;
  display: flex;
  width: 229px;
  padding: 10px;
  border-radius: 10px;
  background-color: v-bind(backgroundColor);
  justify-content: space-between;
  margin: 10px 5px;
  word-break: break-word;
}

.portal-item__title {
  width: 74%;
  display: flex;
  font-size: 18px;
  color: v-bind(textColor);
  font-weight: bold;
  align-items: flex-end;
}

.portal-item__image {
  height: 50px;
  width: 50px;
  margin: auto 0;
  border-radius: 50px;
  background-color: v-bind(textColor);
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 991px) {
  .portal-item__container {
    min-width: 180px;
  }

  .portal-item__title {
    font-size: 15px;
    font-weight: 500;
  }

  .portal-item__image > img {
    height: 26px;
  }
}
</style>
